// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0.41 0.41 10 6'
    ...attributes
  ><path
      fill='none'
      stroke='var(--icon-color,#000)'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
      d='m1.414 1.414 4 4 4-4'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'CaretDown';
export default IconComponent;
